const _rtEnv: Record<string, string> = (window as any).__env || {};
export const environment = {
   production: false,
   appVersion: require('../../package.json').version,
   apiBaseUrl: _rtEnv['API_URL'] || "undefined",
   apiBaseUrlV2: _rtEnv['API_URL_V2'] || "undefined",
   timeStamp:  "2025-05-14T04:41:40Z", //Only in UTC format
   firebaseConfig: {
       apiKey: _rtEnv['FIRE_API_KEY'] || "undefined",
       authDomain: _rtEnv['FIRE_AUTH_DOMAIN'] || "undefined",
       projectId: _rtEnv['FIRE_PROJECT_ID'] || "undefined",
       storageBucket: _rtEnv['FIRE_STORAGE_BUCKET'] || "undefined",
       messagingSenderId: _rtEnv['FIRE_MSG_SENDER_ID'] || "undefined",
       appId: _rtEnv['FIRE_APP_ID'] || "undefined",
       measurementId: _rtEnv['FIRE_MEASUREMENT_ID'] || "undefined"
   },
   restrictedRoutes: [],
   disabledFeatures: {
      tagSelection: false,
      chatGPTMsg: false,
      manageInterest: false,
      orgUserV2: false,
      surveyResponseV: false,
      mobileVersion: false,
      usersUploadCenter: false
   },
   inMaintanence: false,
   newRelic: {
      applicationID: _rtEnv['NEW_RELIC_APP_ID'] || "undefined",
      licenseKey: _rtEnv['NEW_RELIC_LICENSE_KEY'] || "undefined"
   },
   suffix: _rtEnv['ENVIRONMENT_SUFFIX'] || "undefined",
   intercomAppId: _rtEnv['INTERCOM_APP_ID'] || "undefined",
   maxBulkUploadFileSizeMB: 30,
   enterprisePortalUrl: _rtEnv['ENTERPRISE_PORTAL_URL'] || "",
   enableManageServices: (_rtEnv['ENABLE_MANAGE_SERVICES'] ?? "false") === 'true',
   useEnterpriseReferrals: (_rtEnv['USE_ENTERPRISE_REFERRALS'] ?? "true") === 'true',
   enableNotifications: (_rtEnv['ENABLE_NOTIFICATIONS'] ?? "false") === 'true'
} 